import React, { useState, useEffect } from 'react';
import './AddNewspaper.css';
import * as Constants from '../../Constant/constant';

function AddNewspaper() {
  const [showAddNewspaper, setShowAddNewspaper] = useState(true);
  const [newspaper_name, setNewspaperName] = useState('');
  const [publisher, setPublisher] = useState('');
  const [newspapers, setNewspapers] = useState([]);
  const [loadingNewspapers, setLoadingNewspapers] = useState(false);
  const [errorNewspapers, setErrorNewspapers] = useState(null);
  const [editingNewspaperId, setEditingNewspaperId] = useState(null);
  const [editingNewspaperName, setEditingNewspaperName] = useState('');
  const [editingPublisher, setEditingPublisher] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15; // 👈 You can set 5 or 10 based on your choice
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    fetchNewspapers();
  }, []);

  const fetchNewspapers = async () => {
    setLoadingNewspapers(true);
    setErrorNewspapers(null);
    try {
      const response = await fetch(`${Constants.API_PATH}/newspaper`);
      if (!response.ok) throw new Error('Failed to fetch newspapers');
      const data = await response.json();
      setNewspapers(data);
    } catch (error) {
      setErrorNewspapers(error.message);
    } finally {
      setLoadingNewspapers(false);
    }
  };

  const handleAddNewspaper = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${Constants.API_PATH}/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newspaper_name, publisher }),
      });
      if (!response.ok) throw new Error('Failed to add newspaper');
      setNewspaperName('');
      setPublisher('');
      fetchNewspapers();
    } catch (error) {
      setErrorNewspapers(error.message);
    }
  };

  const openEditModal = (newspaper) => {
    setEditingNewspaperId(newspaper.id);
    setEditingNewspaperName(newspaper.newspaper_name);
    setEditingPublisher(newspaper.publisher);
    setShowEditModal(true);
  };

  const handleUpdateNewspaper = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${Constants.API_PATH}/update/${editingNewspaperId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newspaper_name: editingNewspaperName, publisher: editingPublisher }),
      });
      if (!response.ok) throw new Error('Failed to update newspaper');
      setShowEditModal(false);
      fetchNewspapers();
    } catch (error) {
      setErrorNewspapers(error.message);
    }
  };

  const handleDeleteNewspaper = async (id) => {
    if (window.confirm('Are you sure you want to delete this newspaper?')) {
      try {
        const response = await fetch(`${Constants.API_PATH}/usercrud/${id}`, {
          method: 'DELETE',
        });
        if (!response.ok) throw new Error('Failed to delete newspaper');
        fetchNewspapers();
      } catch (error) {
        setErrorNewspapers(error.message);
      }
    }
  };

  const totalPages = Math.ceil(newspapers.length / itemsPerPage);

  const handlePagination = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNewspapers = newspapers.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="add-newspaper-section containernew">
      <nav className="breadcrumb">
        <a href="#" className="breadcrumb-link">Home</a> /
        <a href="#" className="breadcrumb-link">Library Management</a> /
        <span className="breadcrumb-current">Add Newspaper</span>
      </nav>

      <h2 className="section-title">Add Newspaper</h2>

      <form onSubmit={handleAddNewspaper} className="newspaper-form">
        <div className="form-group">
          <label htmlFor="newspaperName" className="form-label">Newspaper Name *</label>
          <input
            type="text"
            id="newspaperName"
            className="form-input"
            placeholder="Newspaper Name"
            value={newspaper_name}
            onChange={(e) => setNewspaperName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="publisher" className="form-label">Publisher</label>
          <input
            type="text"
            id="publisher"
            className="form-input"
            placeholder="Publisher"
            value={publisher}
            onChange={(e) => setPublisher(e.target.value)}
          />
        </div>

        <button type="submit" className="add-button">Add</button>
      </form>

      <div className="newspaper-list">
        <h3>Newspaper List</h3>
        {loadingNewspapers ? (
          <p>Loading newspapers...</p>
        ) : errorNewspapers ? (
          <p>{errorNewspapers}</p>
        ) : (
          <>
            <table className="newspaper-table custom-table">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Name</th>
                  <th>Publisher</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentNewspapers.map((newspaper, index) => (
                  <tr key={newspaper.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{newspaper.newspaper_name}</td>
                    <td>{newspaper.publisher}</td>
                    <td>
                      <button onClick={() => openEditModal(newspaper)}>Edit</button>
                      <button onClick={() => handleDeleteNewspaper(newspaper.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination Buttons */}
            {newspapers.length > 0 && (
              <div className="pagination">
                <button
                  disabled={currentPage === 1}
                  onClick={() => handlePagination(currentPage - 1)}
                >
                  <span style={{margin:"auto"}}>&laquo;</span>
                </button>
                {Array.from({ length: totalPages }).map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => handlePagination(index + 1)}
                    className={currentPage === index + 1 ? 'active' : ''}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => handlePagination(currentPage + 1)}
                >
                 <span style={{margin:"auto"}}>&raquo;</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* Edit Newspaper Modal */}
      {showEditModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => setShowEditModal(false)}>&times;</span>
            <h2>Edit Newspaper</h2>
            <form onSubmit={handleUpdateNewspaper}>
              <label>Newspaper Name:</label>
              <input
                type="text"
                value={editingNewspaperName}
                onChange={(e) => setEditingNewspaperName(e.target.value)}
              />
              <label>Publisher:</label>
              <input
                type="text"
                value={editingPublisher}
                onChange={(e) => setEditingPublisher(e.target.value)}
              />
              <button type="submit">Update</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddNewspaper;
